<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-6">
        <div
          class="d-flex align-items-center"
          style="padding: 0%;"
        >
          <b-link
            class="font-weight-bold d-block text-nowrap mr-3 mb-2"
          >
            <el-button
              style="border: none; background-color: transparent;"
              type="button"
              class="is-plain"
              @click="limparStorage"
            >
              <i class="el-icon-back" />
              Voltar
            </el-button>
          </b-link>
        </div>
        <b-card-code
          title="Título"
          :style="{ boxSizing: 'border-box' }"
        >
          <div class="col">
            <b-form-input
              v-model="valueTitulo"
              type="text"
              debounce="500"
            />
          </div>
          <div class="divider" />
          <div class="row">
            <div class="col">
              <div class="divider" />
              <div class="col-md-4">
                <b-form-group class="mb-0">
                  <b-form-input
                    v-model="selectedOption"
                    list="my-list-id"
                    placeholder="Pesquisar Video"
                    @input="onSearch(selectedOption)"
                  />
                  <datalist id="my-list-id">
                    <option
                      v-for="size in options"
                      :key="size.id"
                      :label="size.vsl_name"
                      :value="size.vsl_name"
                    />
                  </datalist>
                </b-form-group>
              </div>
              <b-card-code
                title="Video"
                :style="{ minWidth: 'calc(582.2px / 3)', boxSizing: 'border-box' }"
              >
                <div>
                  <b-embed
                    type="iframe"
                    aspect="16by9"
                    :src="selectedValue"
                    allowfullscreen
                  />
                </div>
              </b-card-code>
            </div>
          </div>
        </b-card-code>
      </div>
      <div class="col-12 col-md-6">
        <div class="d-flex justify-content-end align-items-center">
          <div class="mr-3 mb-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="CreateConteudo()"
            >
              Salvar Conteudo
            </b-button>
          </div>
        </div>
        <b-card
          :style="{ height: '610px' }"
        >
          <b-card-code
            title="Editor de conteúdo"
            :style="{ boxSizing: 'border-box', height: '100%' }"
          >
            <quill-editor
              v-model="content"
              :options="snowOption"
              :style="{ height: '70%' }"
            />
          </b-card-code>
        </b-card>
      </div>
      <div class="col-12">
        <b-card class="custom-card align-items-center justify-content-center">
          <b-card-code title="Para poder fazer uploads de arquivos, aperte no botão abaixo.">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="CreateConteudo()"
            >
              Clique para começar
            </b-button>
          </b-card-code>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import {
  BFormInput, BCardText, BFormTextarea, BEmbed, BFormGroup,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { quillEditor } from 'vue-quill-editor'
import Conteudo from '@/services/Conteudo'

// eslint-disable-next-line import/no-cycle
import router from '@/router'
import { useApi } from '@/composables/useApi'
import { UploadFilesService } from '@/services/UploadFiles'

import axios from 'axios'
import Arquivos from '@/views/App/Cursos/Arquivos.vue'
import Pastas from '@/views/App/Cursos/Pastas.vue'

const uploadFilesService = new UploadFilesService()
const api = useApi()

const conteudo = new Conteudo()
export default {
  name: 'CriarConteudo',
  components: {
    Pastas,
    Arquivos,
    quillEditor,
    BCardCode,
    BFormInput,
    BCardText,
    BFormTextarea,
    BEmbed,
    BFormGroup,

  },
  data() {
    return {
      list: [],
      selectedOption: '',
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
      searchQuery: '',
      selectedValue: '',
      options: [],
      valueTextearea: '',
      valueTitulo: '',
      snowOption: {
        theme: 'snow',
      },
      content: '',
      value: '',
      params: {
        id_conteudo: '',
        file_name: '',
        file_bucket_address: '',
        file_key_name: '',
        file_type: '',
        id_user: '',
        file_uid: '',
        selectedObjectId: '',
      },
    }
  },

  computed: {
    selectedUrl() {
      // find the object that matches the selected option
      const option = this.options.find(option => option.vsl_name === this.selectedOption)
      // return its url or an empty string if not found
      return option ? option.vsl_bucket_address : ''
    },

    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    getUidConteudo() {
      return localStorage.getItem('uidConteudo')
    },
  },
  mounted() {
    this.getvsls()
  },
  methods: {
    async CreateConteudo() {
      const params = {
        conteudo_titulo: this.valueTitulo,
        modulo_id: router.currentRoute.params.id,
        conteudo_content: this.content,
        conteudo_files: '',
        conteudo_video_url: this.selectedValue,
        conteudo_sequencia: 1,
        uid: this.getUidConteudo,
        id_vsl: this.selectedObjectId,
      }

      await conteudo.createConteudo(params).then(response => {
        console.log(response)
        this.$notify({
          title: 'Sucesso',
          message: 'Conteúdo criado com sucesso',
          type: 'success',
        })
        localStorage.setItem('idConteudo', response.id)
        console.log(localStorage.getItem('uidConteudo'))
        console.log(localStorage.getItem('idConteudo'))
        router.push({ name: 'editConteudo' })
      })
    },
    onSearch(searchQuery) {
      const selectedObject = this.options.find(
        option => option.vsl_name === searchQuery,
      )

      if (selectedObject) {
        this.selectedObjectId = selectedObject.id
      }

      this.searchQuery = searchQuery
      this.selectedValue = this.selectedUrl
      this.getvsls()
    },
    async getvsls() {
      await api.get(`/getVslUserById?id_user=${this.getUserData.id}&vsl_name=${this.searchQuery}`)
        .then(response => {
          this.options = response.data
        })
    },

    handlePreview(file) {
      console.log('Arquivo pré-visualizado:', file)
    },
    async handleRemove(file) {
      console.log('Arquivo removido:', file)
      await uploadFilesService.delefile(file.uuid)
      const index = this.list.findIndex(item => item.uuid === file.uuid)
      if (index !== -1) {
        this.list.splice(index, 1)
        console.log(`O item com uuid ${file.uuid} foi removido da lista.`)
      } else {
        console.log(`O item com uuid ${file.uuid} não existe na lista.`)
      }
    },
    handleChange(file) {
      this.handleUpload(file, file.uid)
    },
    limparStorage() {
      const id = localStorage.getItem('cursoId')
      return this.$router.push({
        path: `/editCurso/${id}`,
        query: { tab: 'Modulos' },
      })
      localStorage.removeItem('idConteudo')
      localStorage.removeItem('uidConteudo')
      localStorage.removeItem('cursoId')
    },
    async handleUpload(file, uid) {
      const formData = new FormData()
      const caminho = `${this.getUserData.user_file_key}Upload_Files/`
      formData.append('file', file)
      formData.append('caminho', caminho)
      await axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/UploadArquivos`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
        this.params = {
          id_conteudo: this.getUidConteudo,
          file_name: response.data.data.fileNameOrigin,
          file_bucket_address: response.data.data.fileUrl,
          file_key_name: response.data.data.key_filename,
          file_type: response.data.data.file_type,
          id_user: this.getUserData.id,
          file_uid: uid,
        }
        const obj = {
          name: response.data.data.fileNameOrigin,
          url: response.data.data.fileUrl,
          uuid: uid,
        }

        this.list.push(obj)
      })
      await uploadFilesService.uploadfile(this.params).then(() => {
      })
    },
  },

}
</script>

<style scoped>

</style>
